<div class="basket-confirm-header">
  <h2>Спосіб доставки:</h2>
  <div class="basket-confirm-logos">
    <img *ngIf="delivery === 1" src="/assets/images/icons/delicons/1.png">
    <img *ngIf="delivery === 2" src="/assets/images/icons/delicons/2.png">
    <img *ngIf="delivery === 3 || delivery === 11" src="/assets/images/icons/delicons/3.png">
    <img *ngIf="delivery === 5" src="/assets/images/icons/delicons/5.png">
    <img *ngIf="delivery === 7" src="/assets/images/icons/delicons/9.png">
    <img *ngIf="delivery === 8" src="/assets/images/icons/delicons/7.png">
    <img *ngIf="delivery === 9" src="/assets/images/icons/delicons/8.png">
  </div>

  <div class="column">
    <div class="btn-dropdown-delivery">
      <button class="button change-delivery-method">
        Вибір доставки, складу
        <small>
          {{ deliveryCurrent.name }}
          <ng-container *ngIf="deliveryCurrent.id != 2 && deliveryCurrent.id != 7">
            , {{ wars[1].name }}
          </ng-container>
        </small>
      </button>
      <div class="list-dels">
        <ul>
          <li *ngFor="let del of deliveryList" (click)="setDelivery(del.id)">
            <b>{{ del.name }}</b>
            <p [innerHTML]="del.comment"></p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>





